import { StyleSheet } from 'react-native'
import HelperPlatform from 'utils/helper-platform'

export const ThemedModalStyles = StyleSheet.create({
	backdrop: {
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},
	
	modal: {
		flex: 1,
		width: '95%',
		minHeight: 'auto',
		...HelperPlatform.select({
			web: {
				maxWidth: '600px',
				maxHeight: '95%',
				overflow: 'auto',
				left: 0,
				right: 0,
				margin: 0
			}
		})
	},
	
	card: {
		minHeight: 'auto',
		maxHeight: '98%',
	},
	
	cardHeader: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	},
	cardHeaderLeft: {
		flex: 1,
		alignSelf: 'flex-start',
	},
	cardHeaderRight: {
		alignSelf: 'flex-start',
		justifyContent: 'flex-end',
		paddingRight: 0,
	},
	
	cardFooter: {
		flexDirection: "row",
		justifyContent: 'flex-end'
	},
	
	scrollView: {
		flexGrow: 0,
	}
});
